module.exports = __webpack_public_path__ + "img/up.766922aa.png";